import { useEffect } from "react";
import InputError from "@/Components/InputError";
import { Head, useForm } from "@inertiajs/react";
import { useState } from "react";
import { Eye, EyeOff, Plus } from "react-feather";
import { generateUrlParam } from '@/Utils/helper';
import _ from "lodash";
export default function Login({
    authErrors,
    flowType,
    responseType,
    clientId,
    redirectUri,
    clientLogo,
    clientName,
    state,
    status,
    canResetPassword,
    error,
    // isRegisterDisabled = false
}) {
    const getQueryParams = () => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        return params;
    };
    const [showPassword, setShowPassword] = useState(false);
    const { transform, data, setData, post, processing, errors, reset } =
            useForm({
                chamsemaillogin: "",
                chamspasswordlogin: "",
                remember: false,
                entity: "SFL", // ⬅️ TAMBAH ENTITY
                flowType: getQueryParams().get("flow_type"),
                responseType: getQueryParams().get("response_type"),
                clientId: getQueryParams().get("client_id"),
                redirectUri: getQueryParams().get("redirect_uri"),
                clientLogo: clientLogo,
                clientName: clientName,
                state: getQueryParams().get("state"),
            });

        transform((data) => ({
            email: data.chamsemaillogin.toLowerCase(),
            password: data.chamspasswordlogin,
            remember: data.remember,
            entity: data.entity, // ⬅️ KIRIM ENTITY
            flowType: data.flowType,
            responseType: data.responseType,
            clientId: data.clientId,
            redirectUri: data.redirectUri,
            clientLogo: data.clientLogo,
            clientName: data.clientName,
            state: data.state,
        }));

        useEffect(() => {
            return () => {
                reset("chamspasswordlogin");
            };
        }, []);

        const setUrlParam = () => {
            let param = {
                flow_type: data?.flowType,
                response_type: data?.responseType,
                client_id: data?.clientId,
                redirect_uri: data?.redirectUri,
                client_logo: data?.clientLogo,
                client_name: data?.clientName,
                state: data?.state,
            };
            param = _.pickBy(param);
            return param;
        };

        const submit = (e) => {
            e.preventDefault();

            post(route("login-emp.store"), {
                onError: (errors) => {
                    console.log("error ", errors)
                    if (errors.email == "These credentials do not match our records.") {
                        setData("chamspasswordlogin", "");
            }
        },
    });
};

    return (
        <div className="auth-page">
            <Head title="Login" />
            <div className="row g-0">
                <div className="col-12">
                    <div
                        className="auth-bg pt-md-5 p-4"
                        style={{ position: "absolute", width: "100%" }}
                    >
                        <div className="bg-overlay bg-primary fixed h-screen"></div>
                        <ul className="bg-bubbles h-screen">
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                    <div className="p-4">
                        <div className="flex items-center justify-center">
                            {/* <div className="card mt-5 w-11/12 lg:w-2/5 2xl:w-1/4"> */}
                            <div className="card mt-5 w-11/12 lg:w-2/5 2xl:w-1/4">
                                <div
                                    className="card-body"
                                    style={{ paddingTop: "0" }}
                                >
                                    <div className="flex flex-col">
                                        <div
                                            style={{
                                                position: "absolute",
                                                marginTop: "15px",
                                                marginLeft: "-15px",
                                            }}
                                        >
                                            <img
                                                src="/assets/images/logo-kalbe-consumer-revisi.png"
                                                className="w-[50px] xl:w-[97px]"
                                            />
                                        </div>
                                        <div className="flex mt-4 mb-1 mb-md-1 text-center max-w-screen-lg mx-auto">
                                            {data?.flowType == "external" &&
                                            (data?.clientLogo ||
                                                data?.clientName) ? (
                                                <>
                                                    <a
                                                        href="#"
                                                        className="auth-logo mt-4"
                                                    >
                                                        <img
                                                            // src="/assets/images/logo-chams-revisi.png"
                                                            src="/assets/images/orbit-pay-transparent.png"
                                                            className="w-[60px] xl:w-[128px]"
                                                        />
                                                    </a>
                                                    <a className="auth-logo mt-4 content-center">
                                                        <Plus />
                                                    </a>

                                                    <a
                                                        href="#"
                                                        className="auth-logo  mt-4 content-center"
                                                    >
                                                        {data?.clientLogo ? (
                                                            <img
                                                                alt={
                                                                    data?.clientName
                                                                }
                                                                src={
                                                                    data?.clientLogo
                                                                }
                                                                className="w-[60px] xl:w-[128px]"
                                                            />
                                                        ) : (
                                                            <div className="w-[60px] xl:w-[128px]">
                                                                <div className="badge badge-accent badge-outline text-md p-4">
                                                                    {
                                                                        data?.clientName
                                                                    }
                                                                </div>
                                                            </div>
                                                        )}
                                                    </a>
                                                </>
                                            ) : (
                                                <a
                                                    href="#"
                                                    className="block auth-logo"
                                                >
                                                    <img
                                                        // src="/assets/images/logo-chams-revisi.png"
                                                        src="/assets/images/orbit-pay-transparent.png"
                                                        className="w-[120px] xl:w-[256px]"
                                                    />
                                                </a>
                                            )}
                                        </div>
                                        <div className="my-auto">
                                            {error ? (
                                                <>
                                                    <div className="text-center text-2xl font-bold">
                                                        Access blocked
                                                    </div>
                                                    <div className="text-center text-xl font-bold mb-5">
                                                        authorization error
                                                    </div>
                                                    <div className="text-center">
                                                        <InputError
                                                            message={
                                                                error?.response_type
                                                            }
                                                            className="mt-3"
                                                        />
                                                        <InputError
                                                            message={
                                                                error?.client_id
                                                            }
                                                            className="mt-3"
                                                        />
                                                        <InputError
                                                            message={
                                                                error?.redirect_uri
                                                            }
                                                            className="mt-3"
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                <form
                                                    method="post"
                                                    className="mt-4 pt-2"
                                                    onSubmit={submit}
                                                >
                                                    <div className="text-center">
                                                        <h5 className="mb-0">
                                                            Employee Login Page
                                                        </h5>
                                                        <p className="text-muted mt-2">
                                                            Sign in to continue
                                                            to Orbit Pay as Employee.
                                                        </p>
                                                    </div>
                                                    <div className="row mb-4">
                                                    <div className="col">
                                                            <label className="form-label d-block mb-2">Entity</label>

                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="entity-sfl"
                                                                    name="entity"
                                                                    value="SFL"
                                                                    checked={data.entity === "SFL"}       // ⬅️ penting!
                                                                    onChange={(e) => setData("entity", e.target.value)}   // ⬅️ penting!
                                                                />
                                                                <label className="form-check-label" htmlFor="entity-sfl">
                                                                    Sakafarma
                                                                </label>
                                                            </div>

                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="entity-b7"
                                                                    name="entity"
                                                                    value="B7"
                                                                    checked={data.entity === "B7"}        // ⬅️ penting!
                                                                    onChange={(e) => setData("entity", e.target.value)}   // ⬅️ penting!
                                                                />
                                                                <label className="form-check-label" htmlFor="entity-b7">
                                                                    Bintang Toedjoe
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>




                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                        {data.entity === "SFL" ? "Email UPN" : "Radius"}
                                                    </label>
                                                        <input
                                                            // type="email"
                                                            name="chamsemaillogin"
                                                            className="form-control"
                                                            id="chamsemaillogin"
                                                            placeholder={`Enter ${data.entity === "SFL" ? "Email UPN" : "Radius"}`}
                                                            value={
                                                                data.chamsemaillogin
                                                            }
                                                            /* isFocused={true} */
                                                            onChange={(e) =>
                                                                setData(
                                                                    "chamsemaillogin",
                                                                    e.target
                                                                        .value,
                                                                )
                                                            }
                                                        />
                                                        <InputError
                                                            message={
                                                                errors.email
                                                            }
                                                            className="mt-2"
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <div className="d-flex align-items-start">
                                                            <div className="flex-grow-1">
                                                                <label className="form-label">
                                                                    Password
                                                                </label>
                                                            </div>
                                                        </div>

                                                    <div className="">
                                                        <div className="relative">
                                                            <input
                                                                type={
                                                                    showPassword
                                                                        ? "text"
                                                                        : "password"
                                                                }
                                                                name="chamspasswordlogin"
                                                                className="form-control"
                                                                placeholder="Enter password"
                                                                aria-label="Password"
                                                                aria-describedby="password-addon"
                                                                onChange={(e) =>
                                                                    setData(
                                                                        "chamspasswordlogin",
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                value={
                                                                    data.chamspasswordlogin
                                                                }
                                                            />
                                                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                                                                {showPassword ? (
                                                                    <Eye
                                                                        onClick={() =>
                                                                            setShowPassword(
                                                                                false
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <EyeOff
                                                                        onClick={() =>
                                                                            setShowPassword(
                                                                                true
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <InputError
                                                            message={
                                                                errors.password
                                                            }
                                                            className="mt-2"
                                                        />
                                                    </div>
                                                </div>                                               
                                                {/* <div className="row mb-4">
                                                    <div className="col">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="remember-check"
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="remember-check"
                                                            >
                                                                Remember me
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="mb-3">
                                                    <button
                                                        className="btn btn-primary w-100 waves-effect waves-light"
                                                        type="submit"
                                                        disabled={processing}
                                                    >
                                                        Log In
                                                    </button>
                                                </div>
                                            </form>
                                            )}

                                            
                                                    {/* <div className="d-flex justify-content-center">
                                                       <div className="d-flex align-items-center my-2">
                                                            <hr className="flex-grow-1" />
                                                            <span className="mx-3 text-muted small text-uppercase">Or login to</span>
                                                            <hr className="flex-grow-1" />
                                                        </div>

                                                       <a 
                                                            href={route("login")} 
                                                            className="btn btn-outline-dark d-flex align-items-center justify-content-center gap-2 py-2 mt-2" 
                                                            style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-box-seam text-success" viewBox="0 0 16 16">
                                                                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.722V6.828L1 4.24v7.922zm-.514-8.852L.846 3.5 1 3.439 7.5 6.039z"/>
                                                            </svg>
                                                            <span className="fw-bold" style={{ fontSize: '12px' }}>VENDOR PORTAL</span>
                                                        </a>
                                                    </div> */}

                                            <div className="mt-4 mt-md-5 text-center">
                                                <p className="mb-0">
                                                    ©{" "}
                                                    <script nonce="{{ csp_nonce() }}">
                                                        2026
                                                    </script>{" "}
                                                    Orbit Pay
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
